module.exports = __webpack_public_path__ + "static/img/seckill_sm_btn.1c182454.png";